import Image from "../Image/Image";
import { AddressInterface } from "../Interface/AddressInterface";
import { AttachmentInterface } from "./Entities/Attachment/AttachmentInterface";
import { MainTenant } from "./Entities/ContactForContract/Type/Types/MainTenant";

abstract class Factory {

  public abstract create(param);

  public getAvatar(attachments: AttachmentInterface[], defaultIcon: string): string {
    const images = attachments.filter(
      (attachment: AttachmentInterface) => attachment.extension.indexOf("image/") !== -1
    );

    // If we don't have any images, return default icon.
    if (images.length === 0) {
      return Image.get(defaultIcon);
    }

    const avatars = images.filter((attachment: AttachmentInterface) => attachment.isAvatar === true);

    // If we don't have an image which is set as avatar, then we have to return the first attachment as avatar.
    if (avatars.length === 0) {
      if (images.length === 0) {
        return Image.get(defaultIcon);
      } else if(defaultIcon === "user") {
        return images[0].cropImgPath;
      }
      else {
        return images[0].cropImgPath;
      }
    }

    return avatars[0].cropImgPath;
  }

  public getPersons(contacts: string[] | any): number[] {
   if (!contacts) {
     return [];
   }

   return contacts.map(contact => contact.id);
  }

  public getProperties(properties: string[] | any): number[] {
   if (!properties) {
     return [];
   }

   return properties.map(property => property.id);
  }

  public getContracts(contracts: string[] | any): number[] {
   if (!contracts) {
     return [];
   }

   return contracts.map(contract => contract.id);
  }

  public getUnits(units: string[] | any): number[] {
   if (!units) {
     return [];
   }

   return units.map(unit => unit.id);
  }

  public getAdditionalPersons(contactForContracts: any[]): any {
    if (!contactForContracts) {
      return [];
    }

    // Return the persons except the Tenant.
    return contactForContracts.filter(contract => {
      return contract.contactForContractTypeId !== MainTenant.contactForContractTypeId;
    });
  }

  public generateAddress(address: any): AddressInterface {
    const res: AddressInterface = {
      id: 0,
      googlePlaceId: "",
      countryIsoCode: "",
      country: "",
      postalCode: "",
      administrativeAreaLevel1: "",
      administrativeAreaLevel2: "",
      administrativeAreaLevel3: "",
      administrativeAreaLevel1Long: "",
      administrativeAreaLevel2Long: "",
      administrativeAreaLevel3Long: "",
      route: "",
      routeLong: "",
      locality: "",
      localityLong: "",
      sublocality: "",
      sublocalityLong: "",
      sublocalityLevel1: "",
      sublocalityLevel2: "",
      sublocalityLevel1Long: "",
      sublocalityLevel2Long: "",
      formattedAddress: "",
      lat: 0,
      lng: 0,
      streetNumber: "",
      fullAddress: {}
    };
    if (address === null || typeof address === "undefined") {
      return res;
    }
    Object.keys(res || {}).forEach(key => {
      if (address[key] !== null) {
        res[key] = address[key];

        if (key === "fullAddress") {
          res[key] = JSON.parse(address[key]);
        }
      }
    });

    res.lat = Number(res.lat);
    res.lng = Number(res.lng);

    return res;
  }

  public createFromArray(data: any[] = [], reorder: boolean = true): any[] {
    if (data === null || typeof data === "undefined") {
      return [];
    }

    if (reorder === true) {
      data.sort((current, next) => current.id - next.id);
    }

    return data.map(single => {
      return this.create(single);
    });
  }
}

export default Factory;
